import { LogoImage } from "../Logo";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-black" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-12">
        <div className="max-w-md">
          <LogoImage className="h-16 w-auto mb-8" />
          <p className="text-xs leading-relaxed text-white" data-testid="footer-disclaimer">
            SHE Global™ Institute and the SHE Global™ Boardroom Accelerator are currently in pre-launch.
            Enrollment is not open. The Institute does not claim accreditation, does not imply regulatory
            approval, and does not promise board placements or employment. Expressing interest is
            non-binding.
          </p>
        </div>
        <div className="text-xs text-white space-y-3 md:text-right">
          <p className="tracking-[0.3em] uppercase text-[#D4AF37]">Contact</p>
          <p>
            <a href="mailto:admin@sheglobal.global" className="hover:text-[#D4AF37] transition-colors duration-300" data-testid="footer-email-link">
              admin@sheglobal.global
            </a>
          </p>
          <p>
            <a href="https://sheglobal.global" className="hover:text-[#D4AF37] transition-colors duration-300" data-testid="footer-domain-link">
              sheglobal.global
            </a>
          </p>
          <p>
            <a href="/admin/login" className="text-[#5b5b63] hover:text-[#D4AF37] transition-colors duration-300" data-testid="footer-admin-link">
              Administrator
            </a>
          </p>
        </div>
      </div>
      <div className="gold-hairline mt-14" />
      <p className="mt-8 text-[0.65rem] tracking-[0.25em] uppercase text-[#5b5b63]" data-testid="footer-copyright">
        © {new Date().getFullYear()} SHE Global™ Institute. All rights reserved.
      </p>
    </div>
  </footer>
);
